import { Record } from 'immutable';
import { actionTypes } from './title.actions';
import { authActions } from '../auth';
import { tenantHelpers } from '../tenantInfo';

export const TitleState = Record({
  currentTitle: '',
  currentMessage: ''
});

export const titleReducer = (state = new TitleState(), action) => {
  switch (action.type) {
    case actionTypes.UPDATE_TITLE:
      return state.set('currentTitle', action.value);
    case actionTypes.UPDATE_MESSAGE:
      return state.set('currentMessage', action.value);
    case authActions.actionTypes.DELETE_CURRENT_SESSION_SUCCESS:
      return state.set('currentMessage', `You have successfully logged out of ${tenantHelpers.getProductName()}. You can log in again below.`);
    default:
      return state
  }
}
